export const BASE_URL = process.env.REACT_APP_NA_BASE_API_URL;

// Need Analysis API
export const SAVE_SESSION = `${BASE_URL}/save-session-data/`;
export const SAVE_USER_CLICKS = `${BASE_URL}/save-user-clicks/`;
// export const SAVE_NEED = `${BASE_URL}/save-need/`;
export const FETCH_EXPENSE_LIST = `${BASE_URL}/expense-list/`;
export const FETCH_ALL_DATA = `${BASE_URL}/get-all-data/`;
export const SAVE_FAMILY_PRODUCT_DETAILS = `${BASE_URL}/save-family-product-details/`;
export const SAVE_FAMILY_DETAILS = `${BASE_URL}/save-family-details/`;
export const SAVE_PRODUCT_CHANGE_DETAILS = `${BASE_URL}/save-product-change-details/`;
export const GET_FAMILY_PRODUCT_DETAILS = `${BASE_URL}/get-family-product-details/`;
//export const GET_RECOMMENDATION = `${BASE_URL}/get-recommendation/`;
export const GET_PINCODE = `${BASE_URL}/pin-code/`;
export const AUTH_TOKEN = `${BASE_URL}/auth/oauth2-token/`;
export const LOGIN = `${BASE_URL}/auth/login/`;
export const GENERATE_TOKEN = `${BASE_URL}/auth/generate-token/`;
export const REFRESH_TOKEN = `${BASE_URL}/refresh-token/`;
export const VERIFY_TOKEN = `${BASE_URL}/auth/verify-token/`;
export const LOGOUT = `${BASE_URL}/auth/logout/`;
export const OTP = `${BASE_URL}api/otp/`;
export const FETCH_AGENTS_LIST = `${BASE_URL}/fetch-agents-list/`
export const GET_SPCODE_DETAILS = `${BASE_URL}/get-sp-details-for-sams/`

// Masters Data
export const OCCUPATION_MASTER = `${BASE_URL}/occupation/`;
export const EDUCATION_MASTER = `${BASE_URL}/education/`;
export const CATEGORY_MASTER = `${BASE_URL}/category/`;
export const JOURNEY_MASTER = `${BASE_URL}/journey/`;
export const LIFE_COVER_MASTER = `${BASE_URL}/life-cover/`;
export const NEED_MASTER = `${BASE_URL}/need-master/`;
export const NATIONALITY_MASTER = `${BASE_URL}/nation-master/`;
export const SALUTATION_MASTER = `${BASE_URL}/salutation/`;
export const MONTHLY_INCOME_MASTER = `${BASE_URL}/monthly-income-master/`;

//Calculators
export const PROTECTION_CALCULATOR = `${BASE_URL}/protection-family-calculator/`;
export const RETIREMENT_CALCULATOR = `${BASE_URL}/save-retirement-calculator/`;


export const SAVE_PRE_NEED_DATA = `${BASE_URL}/save-pre-need-data/`;
export const CHECK_FAMILY_DETAILS = `${BASE_URL}/check-family-details-V2/`

// export const EXISTING_CUSTOMER_TYPE = `${BASE_URL}api/customer-type/`;

export const CHANGE_PASSWORD = `${BASE_URL}api/change-password/`;

export const QUOTATION_API = `${BASE_URL}/save-quotation-id/`;
// export const SOLUTION_API = `${BASE_URL}/get-solution-data/`;

// GI Api
export const BI = `${BASE_URL}/get-bi-data/`;

// Get Premium with min, max and recommended values
export const GET_PREMIUM_API = `${BASE_URL}/get-multi-target-premium/`

// Add Remove Assured
export const ADD_REMOVE_ASSURED = `${BASE_URL}/add-remove-insured/`;

export const DESELECT_EXPENSE = `${BASE_URL}/delete-journey-expense/`;
export const DESELECT_EMI = `${BASE_URL}/delete-journey-emi/`;


export const FETCH_BI_DATA_BASED_ON_PROVIDED_RECOMMENDATION = `${BASE_URL}/use-recommended-value/`;

export const GET_ELIGIBLE_PROPOSER_LIST = `${BASE_URL}/get-eligible-proposer-list/`;
export const GET_ELIGIBLE_LA_LIST = `${BASE_URL}/get-eligible-la-list/`;
export const CHANGE_LA = `${BASE_URL}/change-la/`

export const PRAGATI_INBOUND_DATA = `${BASE_URL}/pragati-na-inbound-data/`
export const HL_API = `${BASE_URL}/hl-agent-info-wrapper/`
export const BANCA_DETAILS_API = `${BASE_URL}/banca-wrapper/`
export const GENERATE_SOLUTION_DATA = `${BASE_URL}/generate-solution-data/`
export const DISTRIBUTED_APP_INBOUND_DATA = `${BASE_URL}/distributedApp-na-inbound-data/`

export const SAVE_RISK_TYPE = `${BASE_URL}/save-risk-type/`

/** V2 APIs */
export const SAVE_NEED = `${BASE_URL}/v2/save-need/`;
export const GET_RECOMMENDATION = `${BASE_URL}/v2/get-recommendation/`;
export const CHANGE_LIFE_ASSURED = `${BASE_URL}/v2/change-life-assured/`
export const REMOVE_NEED = `${BASE_URL}/v2/remove-need-solution/`
export const CHANGE_PROPOSER = `${BASE_URL}/v2/change-proposer/`
export const REMOVE_LA = `${BASE_URL}/v2/remove-la/`;
export const RESELECT_LA = `${BASE_URL}/v2/reselect-la/`;
export const SELECT_NEED = `${BASE_URL}/v2/reselect-need-solution/`;
export const ADD_NEED = `${BASE_URL}/v2/add-need/`;
export const ADD_INSURED = `${BASE_URL}/v2/add-insured/`;
export const PRODUCT_CHANGE_REASONS = `${BASE_URL}/change-product-reason/`
export const FETCH_CHANGE_PRODUCT_LIST = `${BASE_URL}/fetch-change-product-list/`
export const CHANGE_PRODUCT = `${BASE_URL}/v2/change-product/`
export const CHANGE_TARGET_AMOUNT = `${BASE_URL}/v2/change-target-amount/`;

export const SAVE_COMMUNICATION_DETAILS = `${BASE_URL}/save-communication-details/`
/** SAMS APIs */
export const CREATE_LEAD_SAMS = `${BASE_URL}/create-lead-for-sams/`
export const CREATE_UPDATE_LEAD_SAMS = `${BASE_URL}/create-update-sams-lead/`
export const SMAS_LEAD_STATUS = `${BASE_URL}/sams-lead-status/`
export const SMAS_LEAD_UPDATE = `${BASE_URL}/sams-lead-update/`
export const GET_SAMS_HOME_URL = `${BASE_URL}/back-to-sams/`
export const REVERSE_LEAD_STATUS = `${BASE_URL}/reverse-lead-status/`;

export const FETCH_MULTIPLE_DMS_DOCUMENT = `${BASE_URL}/fetch_multiple_dms_document/`
export const SEND_PDF = `${BASE_URL}/send-pdf/`
export const SOLUTION_API = `${BASE_URL}/get-solution-data-v2/`;
export const GET_REVISED_RECO_SA_TERM_NEED = `${BASE_URL}/get-revised-reco-sa-term-need/`

export const FETCH_PRODUCT_TIME_LINE = `${BASE_URL}/fetch-product-timeline/`;
export const SAVE_SMOKER_STATUS = `${BASE_URL}/save-smoker-status/`;
export const SAVE_CURRENT_SCREEN = `${BASE_URL}/save-current-screen-state/`;
export const REMOVE_SECONDARY_LA = `${BASE_URL}/remove-secondary-la/`;
export const SHOW_COMPARE_PRODUCT_TOOLTIP = `${BASE_URL}/show-compare-product-tooltip/`;
export const GET_LA_CASH_FLOW_DATA = `${BASE_URL}/get-la-cash-flow-data/`;
export const GET_PRODUCTS_LIST = `${BASE_URL}/get-products-list/`;
export const SAVE_QMS_FILTER_USER_CLICKS = `${BASE_URL}/save-qms-filter-user-clicks/`;
export const SAMS_API = `${BASE_URL}/sams-pragati-lead-validated/`;
export const CREATE_AGENT_TOKEN = `${BASE_URL}/create-agent-token/`;


// QMS API list 
export const GET_QMS_LIST = `${BASE_URL}/get-qms-list-data/`
export const GET_QMS_LEAD_DETAILS = `${BASE_URL}/get-qms-lead-details/`;
export const FETCH_SOLUTION_PDF_FROM_DMS = `${BASE_URL}/fetch-solution-pdf-from-dms/`;
export const PRAGATI_QMS_INBOUND_DATA = `${BASE_URL}/pragati-qms-inbound-data/`;
export const NA_QUOTE_STATUS_UPDATE = `${BASE_URL}/na-quote-status-update/`;
export const AGENT_ULIP_TRAINING = `${BASE_URL}/agent-ulip-training/`;
export const FETCH_AGENTS_HIERARCHY = `${BASE_URL}/fetch-agents-hierarchy/`
export const FETCH_JOURNEY_SUMMARY = `${BASE_URL}/fetch-journey-summary/`
export const GET_NEW_QMS_LIST = `${BASE_URL}/get-new-qms-list-data/`;


export const HIGH_RISK_FLAG_TOGGLE = `${BASE_URL}/show-hide-high-risk/`

export const CHANGE_LA_ALL_NEEDS = `${BASE_URL}/change-la-all-needs/`
export const CHANGE_PR_ALL_NEEDS = `${BASE_URL}/change-pr-all-needs/`
export const CHANGE_SECONDARY_LA_ALL_NEEDS = `${BASE_URL}/change-secondary-la-all-needs/`

export const DOWNLOAD_SIMPLIFIED_SAMPLE_CASHFLOW = `${BASE_URL}/download-simplified-sample-cashflow/`
export const GET_SOLUTION_TIMELINE = `${BASE_URL}/get-solution-timeline-data/`
export const SUBMIT_REVIEW = `${BASE_URL}/submit-review/`


// Time Optimization 
export const GET_RECOMMENDATION_RISK_DETAILS = `${BASE_URL}/v3/get-recommendation/`
export const CREATE_FAMILY_PRODUCT_ID = `${BASE_URL}/create-family-product-id/`
export const ADD_NEW_NEED = `${BASE_URL}/add-new-need/`
export const CHANGE_LA_FAMILY_PRODUCT_ID = `${BASE_URL}/change-la-family-product-id/`
export const CHANGE_NEW_LA = `${BASE_URL}/change-new-life-assured/`
export const ADD_NEW_LA = `${BASE_URL}/add-new-life-assured/`
export const CHANGE_NEW_PR = `${BASE_URL}/change-new-pr/`
export const CHANGE_NEW_TARGET_AMOUNT = `${BASE_URL}/change-new-target-amount/`
export const SELECT_NEW_HIGH_RISK = `${BASE_URL}/select-new-high-risk/`
export const CHECK_NAVIGATION_SCREEN = `${BASE_URL}/check-navigation-screen/`
export const SEND_WHATSAPP_MESSAGE = `${BASE_URL}/send-whatsapp-message/`
export const FETCH_AGENTS_EMAIL_FOR_CC = `${BASE_URL}/fetch-agents-email-for-cc/`
export const BONUS_HISTORY_CALCULATION = `${BASE_URL}/bonus-history-calculation/`
export const VALIDATE_EXISTING_CUSTOMER = `${BASE_URL}/validate-existing-customer/`
export const VALIDATE_EXISTING_FAMILY_CUSTOMER = `${BASE_URL}/validate-existing-family-benefits/`

// BREADCRUMBS -> CHECKBOX PRODUCT DATA FOR SHARE PDF
export const GET_DOCUMENT_LIST = `${BASE_URL}/get-documents-list`
export const SAVE_DOCUMENT_LIST = `${BASE_URL}/save-documents-list/`

//Comapre Product 
export const CHANGE_PRODUCT_FOR_COMPARE = `${BASE_URL}/change-product-for-compare/`
export const PRODUCT_BENEFIt_MAPPING = `${BASE_URL}/product-benefit-mapping/`
export const RECALCULATE_FOR_BI_DATA_FOR_COMAPARE_PRODUCTS = `${BASE_URL}/recalculate-bi-data-for-compare-products/`
export const FILTERED_BENEFIR_LIST = `${BASE_URL}/filtered-benefit-list/`
export const FETCH_PRODUCT_TIME_LINE_BY_QUOTATION = `${BASE_URL}/fetch-product-timeline-by-quotation/`
export const GET_RECO_FROM_FRONTEND_BI = `${BASE_URL}/get-reco-from-frontend-bi/`

//PasaCampaign
export const UPDATE_PASA_OR_NON_PASA_JOURNEY = `${BASE_URL}/update-pasa-or-nonpasa-journey/`;
export const TOTAL_SUM_ASSURED_ALL_PRODUCT= `${BASE_URL}/total-sum-assured-of-all-products/`;
export const FETCH_CAMPAIGN_JOURNEY_SUMMARY = `${BASE_URL}/fetch-campaign-journey-summary/`
export const GET_PASA_CARD_LIST = `${BASE_URL}/get-pasa-card-list/`;
export const SAVE_CAMPAIGN_DATA = `${BASE_URL}/save-campaign-data/`;
export const WHATSAPP_SHARE_CAMPAIGN = `${BASE_URL}/whatsapp-share-campaign/`;
export const SAVE_SOLUCTION_STATUS  = `${BASE_URL}/save-solution-status/`;
export const SAVE_CAMPAIGN_LEAD_ACTION  = `${BASE_URL}/save-campaign-lead-action/`;
export const QMS_CARD_EXPIRING_DATE_LIST  = `${BASE_URL}/qms-card-expiring-date-list/`;
export const ACTIVE_CAMPAIGN_TABS_LIST  = `${BASE_URL}/active-campaign-tabs-list/`;








